import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const FlagDescargarValidacionFormGroup = ({ fIsSubmitting, iValue }) => {
  return (
    <Form.Group>
      <Col md={4} />
      <Col md={8}>
        <Field name='flagDescargarValidacion'>
          {({ field }) => (
            <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagDescargarValidacion' label='Descargar Validacion' />
          )}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(FlagDescargarValidacionFormGroup)
